import React from "react";
import { BsLinkedin, BsGithub, BsTwitter } from "react-icons/bs";
// import { AiTwotoneMail } from 'react-icons/ai';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a
        href="https://www.linkedin.com/in/jithin-sebastian-366272107/"
        target="_blank"
        rel="noreferrer"
      >
        <BsLinkedin />
      </a>
    </div>

    <div>
      <a href="https://github.com/jithinsebastian2" target="_blank" rel="noreferrer">
        <BsGithub />
      </a>
    </div>

    <div>
      <a href="https://twitter.com/JithinSeba45215" target="_blank" rel="noreferrer">
        {/* <BsWhatsapp /> */}
        <BsTwitter />
      </a>
    </div>
  </div>
);

export default SocialMedia;
